import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import '~/utils/i18n';

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    environment: import.meta.env.VITE_ENV ?? import.meta.env.MODE,
    release: import.meta.env.VITE_APP_RELEASE as string | undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ['api.getkarla.ai'],
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    ignoreErrors: ['ResizeObserver loop limit exceeded', 'ResizeObserver loop completed with undelivered notifications', 'Non-Error promise rejection captured', /^Loading chunk \d+ failed/, /^NetworkError/, 'Failed to fetch'],
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (error instanceof Error && error.stack?.includes('chrome-extension://')) return null;
      return event;
    },
  });
}

ReactDOM.hydrateRoot(
  document,
  <React.StrictMode>
    <HydratedRouter />
  </React.StrictMode>,
);
